import * as yup from 'yup'

export const align = [
	...(['top', 'bottom', 'left', 'right', 'center', 'top left', 'top right', 'bottom left', 'bottom right'] as const),
]
export type Align = typeof align[number]

export const fitting = [
	...([
		'fill',
		'fit',
		'stretch',
		'actual_size',
		'original_size',
		'tile',
		'tile_horizontal',
		'tile_vertical',
		'fit_and_tile',
		'legacy_tile',
		'legacy_tile_horizontal',
		'legacy_tile_vertical',
		'legacy_normal',
	] as const),
]
export type Fitting = typeof fitting[number]

export const fittingSchemaField = {
	fittingType: yup.mixed<Fitting>().oneOf(fitting).default(fitting[0]),
}

export const alignmentSchemaField = {
	alignType: yup.mixed<Align>().oneOf(align).default(align[0]),
}

export const filterEffectSchemaObject = yup.object({
	effectType: yup.string(),
	brightness: yup.number().min(0).max(10),
	contrast: yup.number().min(0).max(10),
	saturation: yup.number().min(0).max(10),
	hue: yup.number().min(-180).max(180),
	duotoneDark: yup.string(),
	duotoneLight: yup.string(),
	invert: yup.boolean().default(false),
	isCustom: yup.boolean(),
})
